// extracted by mini-css-extract-plugin
export default {"page_not_fount_container":"PageNotFound_page_not_fount_container__fbtZO","page_not_fount_text":"PageNotFound_page_not_fount_text__oSyt8"};